  import React from 'react';
  import { Line } from 'react-chartjs-2';
  
  //let data: any;
  const LineChart = (props) => {
    
    let labels = props.dateArray; 
    let datas = props.glucoseArray; 
    console.log("Glucoze graph: " + datas)
    let minValue = Math.min( ...props.glucoseArray ) - 2;
    let maxValue = Math.max( ...props.glucoseArray ) + 2;

    // options for LINECHART !!
    const options = {
              responsive: true,
              tooltips: {
                titleFontSize: 12,
                bodyFontSize: 12
              },
              title:{
                display: true,
                text: 'Krvni sladkor',
                fontColor: '#009fd9'
              },
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  fontColor: '#009fd9'
                }
              },
              scales: {
                yAxes: [{
                  display: true,
                  position: 'right',
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    suggestedMax: maxValue,
                    suggestedMin: minValue,
                    stepSize: 10,
                    fontColor: '#009fd9'
                }
                }],
                xAxes: [{
                  gridLines: {
                    display: false,
                 },
                 ticks: {
                  display: false, // doesnt show XAXIS 
                    scaleLabel: {
                      display: true,
                    },
                  fontColor: '#009fd9',
                  autoSkip: true,
                 }
                }]
              }
    }

    //DATA for LINECHART !!
    let data = {
      labels: labels,
      datasets: [
        {
          fill: true,
          //lineTension: 0.5,
          backgroundColor: 'rgb(56, 128, 255, 0.3)',
          //backgroundColor: 'rgb(255, 255, 255, 0.3)',
          borderColor: 'rgb(56, 128, 255, 0.5)',
          //borderColor: 'rgb(255, 255, 255, 0.8)',
          borderWidth: 2,
          label: 'Glukoza',
          fontColor: '#009fd9',
          data: datas
          }
      ]
    }
// GRAPH WORKING - FIX DATE INPUT  

    return  <Line data={data} options={options}/> 
}

  export default LineChart;